export default "__VITE_ASSET__746ee854__"